import { styled } from 'styled-components';

export const CustomContainer = styled.div`
    margin: 0 auto;
    padding: 24px;
    max-width: 688px;

    @media screen and (min-width: 576px) {
        padding: 48px 24px;
    }
`;
